import { render } from "./HeaderMenuDesktop.vue?vue&type=template&id=0186a839"
import script from "./HeaderMenuDesktop.vue?vue&type=script&lang=js"
export * from "./HeaderMenuDesktop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__